module.exports = __webpack_public_path__ + "media/images/logo/fakturaonline-logo-cs-d911e1496e3b90b72d5bb43a05aad77a.svg";